// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { bronos as _bronos } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the bronos chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 1039
 * Chain Name: Bronos
 * Default Block Explorer: https://broscan.bronos.org
 * Default RPC URL: https://evm.bronos.org
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { bronos } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: bronos,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const bronos = createCommon({
	..._bronos,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
